import { createSelector } from '@ngrx/store';
import { ChatState, getChatFeatureState } from '../reducers';

const getCoversationHubState = createSelector(getChatFeatureState, (state: ChatState) => state.conversationHub);

export const getConversationHubLoading = createSelector(getCoversationHubState, (state) => state.loading);
export const getConversationHubReady = createSelector(getCoversationHubState, (state) => state.ready);
export const getConversationHubError = createSelector(getCoversationHubState, (state) => state.error);
